import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { NAV } from "@/constants/testIds";

const links = [
  { id: "benefits", label: "Beneficii", testid: NAV.linkBenefits },
  { id: "ingredients", label: "Ingrediente", testid: NAV.linkIngredients },
  { id: "waitlist", label: "Waitlist", testid: NAV.linkWaitlist },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FDFBF7]/85 backdrop-blur-md border-b border-[#E5DCD3]/60"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <div className="flex items-center justify-between py-5 md:py-6">
          <a
            href="#top"
            data-testid={NAV.brand}
            className="flex items-center gap-3 group"
            aria-label="EILEA"
          >
            <img
              src="/brand/eilea_monogram.png"
              alt=""
              aria-hidden="true"
              className="h-7 md:h-9 w-auto object-contain select-none transition-transform duration-700 group-hover:rotate-[8deg]"
              draggable="false"
            />
            <span className="font-logo text-[1.1rem] md:text-[1.25rem] text-[#2C2826] leading-none tracking-[0.22em]">
              eilea
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-10">
            {links.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                data-testid={l.testid}
                className="overline link-underline text-[#2C2826]/80 hover:text-[#2C2826]"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <a
            href="#waitlist"
            className="hidden md:inline-flex items-center gap-2.5 border border-[#2C2826] px-5 py-2 text-[0.66rem] uppercase tracking-[0.3em] text-[#2C2826] font-light hover:bg-[#2C2826] hover:text-[#FDFBF7] transition-colors duration-500"
          >
            <span className="w-1 h-1 rounded-full bg-[#2C2826] inline-block" />
            Pre-lansare
          </a>

          {/* mobile badge */}
          <a
            href="#waitlist"
            className="md:hidden text-[0.6rem] uppercase tracking-[0.3em] border border-[#2C2826] px-3 py-1.5 text-[#2C2826] font-light"
          >
            Pre-lansare
          </a>
        </div>
      </div>
    </motion.header>
  );
}
